import Particle from './Particles';
import './App.css';
import HomePage from './HomePage';
import HealthCare from './HealthCare';



function App() {
  

  return (
    <div className="App">
      <HealthCare />
    </div>
  );
}

export default App;
